module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-BoldItalic.2750a1e9.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-BoldItalic.woff2
// module id = 527
// module chunks = 0